'use strict';

const Mn = require('backbone.marionette');
const ContentRepository = require('data/domain/repository/content/index');
const ContentListView = require('data/ui/view/content/list');
const Template = require('data/ui/template/content/folder-item.hbs');

class FolderItemView extends Mn.View {
    regions() {
        return {
            contentList: '.content-list'
        };
    }

    get tagName() {
        return 'li';
    }

    get className() {
        return 'list-item content-folder';
    }

    get template() {
        return Template;
    }

    events() {
        return {
            'click > .list-item-icon': 'toggle',
            'click > .list-item-content': 'toggle'
        };
    }

    modelEvents() {
        return {
            'change:open': 'changeOpen'
        };
    }

    childViewTriggers() {
        return {
            'select:content': 'select:content'
        };
    }

    ui() {
        return {
            openStateIcon: '.list-item-icon i'
        };
    }

    toggle() {
        // e.stopPropagation();
        if (this.model.get('open')) {
            this.close();
        } else {
            this.open();
        }
    }

    changeOpen() {
        if (this.model.get('open')) {
            this.$el.css('height', 'auto');
            this.ui.openStateIcon.removeClass('fa-folder');
            this.ui.openStateIcon.addClass('fa-folder-open');
            this.$el.css('overflow', 'none');
        } else {
            this.$el.css('height', '48px');
            this.ui.openStateIcon.addClass('fa-folder');
            this.ui.openStateIcon.removeClass('fa-folder-open');
            this.$el.css('overflow', 'hidden');
        }
    }

    templateContext() {
        return {
            name: this.model.getName()
        };
    }

    onRender() {
        const context = this.getOption('context');
        const project = context.getProject();
        const container = this.model;
        const addedListView = this.getOption('contentListView');
        const ListView = addedListView ? addedListView : ContentListView;

        ContentRepository.find(project)
            .fetchContentsOnce(container.id, 10)
            .then(contents => {
                this.showChildView('contentList', new ListView({
                    content: this.getOption('content'),
                    context: this.getOption('context'),
                    collection: contents,
                    emptyView: this.getOption('emptyView'),
                    presentContents: this.getOption('presentContents'),
                }));
            });

        this.changeOpen();
    }

    open() {
        this.model.set({open: true});
    }

    close() {
        this.model.set({open: false});
    }

    getActiveContents() {
        return this.getChildView('contentList').getActiveContents();
    }

    resetActiveContents() {
        this.getChildView('contentList').resetActiveContents();
    }
}

module.exports = FolderItemView;



// WEBPACK FOOTER //
// ./data/ui/view/content/folder-item.js